<template>
  <div>
    <div class="planningStyle d-flex justify-content-between align-items-center w-100 mb-2">
      <label class="text-main font-weight-bold m-0">
        {{ titleModule }}
      </label>
      <button v-if="parentCanEdit" class="atm-button  shadow-none" @click="editMode()">
        <span class=" material-icons-round text-main">edit</span>
      </button>
    </div>
    <span v-for="(mod, idx) in modulesQuest" :key="idx">
      <b-row v-if="mod.id == moduleOrder" class="mb-3">
        <div class="mt-3 w-100" v-if="mod.question02">
          <div class="d-flex align-items-center">
            <i class="material-icons text-main align-middle mr-1">
              schedule
            </i>
            <p class="font-weight-bold m-0">
              {{ childName }}
              {{ mod.question02 }}
            </p>
          </div>
          <div
            class="calendarStyle atm-rounded atm-shadow d-flex justify-content-center align-items-center overflow-hidden mx-auto mt-3"
          >
            <div
              v-for="(day, idx) in plan.what_days"
              class="d-flex flex-column justify-content-center align-items-center w-100"
              :class="{ calendarBorder: idx + 1 < plan.what_days.length }"
            >
              <p
                class="d-flex align-items-center justify-content-center bg-main text-light text-center font-weight-bold m-0 w-100"
              >
                {{ day.day_name.slice(0, 2) }}
              </p>
              <small
                class="d-flex align-items-center justify-content-center text-center text-uppercase font-weight-bold px-2"
              >
                {{ formatAMPMHour(day.hour) }}
              </small>
            </div>
          </div>
        </div>
        <div
          class="gap-3 d-flex flex-wrap justify-content-around align-items-center mt-3 w-100"
          v-if="mod.question03"
        >
          <div class="d-flex flex-column justify-content-center align-items-center p-2">
            <div class="d-flex justify-content-center align-items-center">
              <i class="material-icons text-main align-middle mr-1">
                location_on
              </i>
              <p class="font-weight-bold m-0">
                {{ mod.question03 }}
              </p>
            </div>
            <p class=" m-0 pt-1 d-inline">
              {{ plan.where_place }}
            </p>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center p-2">
            <div class="d-flex justify-content-center align-items-center">
              <i class="material-icons text-main align-middle mr-1">
                assignment_turned_in
              </i>
              <p class="font-weight-bold m-0">
                {{ childName }}
                {{ mod.question04 }}
              </p>
            </div>
            <p class=" m-0 pt-1">
              {{ plan.what_activities }}
            </p>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center p-2">
            <div class="d-flex justify-content-center align-items-center">
              <i class="material-icons text-main align-middle mr-1">
                notifications
              </i>
              <p class="font-weight-bold m-0">
                {{ mod.question05 }}
              </p>
            </div>
            <p class="m-0 pt-1">
              {{ plan.how_remember }}
            </p>
            <p class="m-0 pt-1" v-if="plan.has_extra">
              {{ plan.extra_data_how_remember }}
            </p>
          </div>
        </div>
        <div class="mt-3 w-100" v-if="mod.question06">
          <div class="d-flex align-items-center font-weight-bold">
            <i class="material-icons text-main align-middle mr-1">
              schedule
            </i>
            <p class="text-capitalize m-0 mr-2">
              {{ parentName }}
            </p>
            <p class=" m-0">
              {{ mod.question06 }}
            </p>
          </div>
          <div
            class="calendarStyle atm-rounded atm-shadow d-flex justify-content-center align-items-center overflow-hidden mx-auto mt-3"
          >
            <div
              v-for="(day, idx) in plan.when_check_days"
              :key="idx"
              class="d-flex flex-column justify-content-center align-items-center w-100"
              :class="{ calendarBorder: idx + 1 < plan.when_check_days.length }"
            >
              <p
                class="d-flex align-items-center justify-content-center bg-main text-light text-center font-weight-bold m-0 w-100"
              >
                {{ day.day_name.slice(0, 2) }}
              </p>
              <small
                class="d-flex align-items-center justify-content-center text-center text-uppercase font-weight-bold px-2"
              >
                {{ formatAMPMHour(day.hour) }}
              </small>
            </div>
          </div>
        </div>
      </b-row>
    </span>
    <div class="d-flex">
      <button class=" bg-main atm-button mx-auto w-50 mt-3" block @click="goChecklist()">
        Show checklist
      </button>
    </div>
  </div>
</template>

<script>
import { formatAMPMHour } from '@/common/utils/Date';
import { useSessionStore } from '@/common/plugins/store';

export default {
  props: {
    plan: { type: Object, required: true },
    moduleOrder: { type: Number, required: true },
    parentName: { type: String, required: true },
    childName: { type: String, required: true },
  },
  methods: {
    editMode() {
      this.$emit('activeEditMode');
    },
    goChecklist() {
      this.$emit('goToCheckList');
    },
  },
  computed: {
    titleModule() {
      return this.moduleOrder === this.SELF_MANAGEMENT_MODULE_ORDER
        ? 'Self-Management Plan'
        : 'Practice Plan';
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  data: function() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      formatAMPMHour,
      SELF_MANAGEMENT_MODULE_ORDER: 5,
      modulesQuest: [
        {
          id: 1,
          title: 'Organization',
          question01: 'will clean up materials and complete the organization checklist',
          question02: 'Clean up materials and complete the organization checklist on:',
          question03: 'At: ',
          question04: 'will:',
          question05: 'To remember',
          question06: 'will check on:',
        },
        {
          id: 2,
          title: 'Homework Recording',
          question01:
            'will check to make sure you recorded all homework/assignments in your calendar',
          question02: 'Check recorded homework/assignments on:',
          question03: 'At:',
          question04: 'will:',
          question05: 'To remember',
          question06: 'will check on:',
        },
        {
          id: 3,
          title: 'Homework Completion',
          question01: 'will work on completing homework each week',
          question02: 'Completing homework each week on:',
          question03: 'At:',
          question04: 'will:',
          question05: 'To remember',
          question06: 'will check on:',
        },
        {
          id: 4,
          title: 'Time Management',
          question01: 'will practice time management/planning each week',
          question02: 'Practice time management/planning each week on:',
          question03: 'At:',
          question04: 'will:',
          question05: 'To remember',
          question06: 'will check on:',
        },
        {
          id: 5,
          title: 'Self management',
          question01: 'will complete the self-management checklist each week',
          question02: 'Complete the self-management checklist each week on:',
          question03: 'At:',
          question04: 'will:',
          question05: 'To remember',
        },
      ],
    };
  },
};
</script>
<style lang="scss">
.calendarBorder {
  border-right: 2px solid var(--color-main);
}

.calendarStyle {
  height: 100px;
  & > div {
    height: 100%;
    & > p {
      flex-grow: 1;
    }
    & > small {
      flex-grow: 2;
    }
  }
}
</style>
